import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisbursementRoutingModule } from './disbursement-routing.module';
import { CashAdvanceComponent } from './cash-advance/cash-advance.component';
import { LiquidationComponent } from './liquidation/liquidation.component';
import { CustomComponentsModule } from '../../custom-components/custom-components.module';
import { DisbursementComponent } from './disbursement.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccMaterialsModule } from '../../utilities/modules/acc-materials/acc-materials.module';
import { AccCustomPipeModule } from '../../utilities/modules/acc-custom-pipe/acc-custom-pipe.module';
import { ReimbursementComponent } from './reimbursement/reimbursement.component';
import { DisbursementNavigatorComponent } from './disbursement-navigator/disbursement-navigator.component';
import { ViewCashAdvanceComponent } from './cash-advance/view-cash-advance/view-cash-advance.component';
import { ReimbursementFormComponent } from './reimbursement/reimbursement-form/reimbursement-form.component';
import { ViewReimbursementComponent } from './reimbursement/view-reimbursement/view-reimbursement.component';
import { DisbursementVoucherComponent } from './disbursement-voucher/disbursement-voucher.component';
import { ViewLiquidationComponent } from './liquidation/view-liquidation/view-liquidation.component';
import { ViewDisbursementVoucherComponent } from './disbursement-voucher/view-disbursement-voucher/view-disbursement-voucher.component';
import { ExportAsModule, ExportAsService } from 'ngx-export-as';
import { ViewReimbursementItemHistoryComponent } from './reimbursement/view-reimbursement-item-history/view-reimbursement-item-history.component';
import { ViewLiquidationItemHistoryComponent } from './liquidation/view-liquidation-item-history/view-liquidation-item-history.component';
import { LiquidationAddItemFormComponent } from './liquidation/liquidation-add-item-form/liquidation-add-item-form.component';


@NgModule({
  declarations: [
    CashAdvanceComponent,
    LiquidationComponent,
    DisbursementComponent,
    ReimbursementComponent,
    DisbursementNavigatorComponent,
    ViewCashAdvanceComponent,
    ReimbursementFormComponent,
    ViewReimbursementComponent,
    DisbursementVoucherComponent,
    ViewLiquidationComponent,
    ViewDisbursementVoucherComponent,
    ViewReimbursementItemHistoryComponent,
    ViewLiquidationItemHistoryComponent,
    LiquidationAddItemFormComponent,
  ],
  imports: [
    CommonModule,
    DisbursementRoutingModule,
    CustomComponentsModule,

    FormsModule,
    ReactiveFormsModule,
    AccMaterialsModule,
    AccCustomPipeModule,
    ExportAsModule,
  ],
  exports: [
  ],
  providers: [
    ExportAsService
  ]
})
export class DisbursementModule { }
